var React = require('react');

function Cz (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"900","height":"600","fill":"#d7141a","key":0}),React.createElement("rect",{"width":"900","height":"300","fill":"#fff","key":1}),React.createElement("path",{"d":"M 450,300 0,0 V 600 z","fill":"#11457e","key":2})]);
}

Cz.defaultProps = {"viewBox":"0 0 900 600"};

module.exports = Cz;

Cz.default = Cz;
